import axios from 'axios';
import {
  baseUrl
} from '../config';
const api = axios.create({
  baseURL: baseUrl
});

const cancelToken = axios.CancelToken.source();

export { cancelToken };

export default api;
